import ResetSendEmailComponent from './../../../../Components/AdminComponents/Auth/ResetPassword/sendEmail';

const ResetSendEmailContainer = () => {
  return <ResetSendEmailComponent />;
};
export default ResetSendEmailContainer;
